export default __webpack_public_path__ + "static/media/0116.183bb867.jpg";